import { SearchSectionEnum, } from 'atlas-shared';

export const SearchSections = [SearchSectionEnum.Conversations, SearchSectionEnum.Contacts, null, ];
